// Porta do módulo para OUTROS MÓDULOS (U06): buscas F0, queries e tipos. A casca e as rotas usam `route.ts`.
import './person.catalog';
export {
  legalPersonOptionSchema,
  legalPersonOptionPageSchema,
  personOptionSchema,
  personOptionPageSchema,
} from './person.wire';
export { administratorSource, personSource } from './person.sources';
export { listLegalPersonOptions, listPersonOptions } from './person.api';
export { legalPersonOptionsQuery, personOptionsQuery } from './person.queries';

export { listNaturalPersonOptions } from './person.api';
export { naturalPersonOptionsQuery } from './person.queries';
export { legalPersonSource, naturalPersonSource } from './person.sources';

// Catálogo de datasets de bureau (P24): a fonte única é `person.datasets.ts`. A Operação de crédito lê daqui
// (abas KYC e Crédito por envolvido, R2): a cópia que morava em `credit-note` saiu. `./datasets` continua a
// porta própria para quem carrega sob demanda.
export const loadPersonDatasets = () => import('./datasets');
export {
  creditEntries,
  datasetFormat,
  datasetHasData,
  datasetItemOf,
  findPersonDataset,
  KYC_LEGAL_PERSON,
  KYC_NATURAL_PERSON,
  PERSON_DATASETS,
} from './person.datasets';
/** O painel de um dataset de uma pessoa e as abas Compliance e Crédito, sob demanda. */
export const loadPersonDatasetPanels = () => import('./screens/person-dataset-tabs');
export type {
  CreditEntry,
  CreditExtra,
  CreditTabFlags,
  DatasetColumn,
  DatasetField,
  DatasetFormat,
  DatasetItem,
  DatasetSection,
  PersonDatasetSpec,
  PersonRecordType,
} from './datasets';

// Registro de pessoa para outros módulos (leitura) e o caminho do cadastro no novo UYZY.
export { legalPersonDetailQuery, naturalPersonDetailQuery, personKeys } from './person.queries';
export { personKindOf, personListPath, personRecordPath, type PersonKind } from './person.kind';
export type { LegalPerson, NaturalPerson } from './person.wire';

// Read-only payer details consumed by Billing.
export { getPersonForBilling, personForBillingQuery, type PersonForBilling, type PersonForBillingInput } from './person-billing';

// Cadastro rápido de PF/PJ (P16+, `DrawerAddPerson` do legado) para Crédito, Contas e Desconto: a porta é
// leve e o sheet carrega na primeira abertura.
export {
  needsPersonAdditionalInfo,
  PersonQuickCreate,
  type PersonQuickCreateFlow,
  type PersonQuickCreateProps,
  type PersonQuickCreateResult,
} from './person-quick-create';

// Dados bancários da pessoa (unidade 10E) para o Resumo da simulação: adicionar ou editar uma conta, com prévia; grava
// só a conta escolhida. A porta é leve e o diálogo carrega na primeira abertura.
export { PersonBankAccountSheet, type PersonBankAccountSheetProps } from './person-bank-account-sheet';
export type { BankAccountSaved } from './person-bank-account-sheet.types';
// "Abrir conta" (reservar o número da conta transitória da PF) do drawer de dados bancários da operação: porta leve.
export { PersonOpenBankAccount, type PersonOpenBankAccountProps } from './person-open-bank-account';

// "Carregar informações" (`GET /Person/{documento}/QueryBasicData`) para o "Adicionar favorecido" de Contas
// digitais (`BankAccountFavoredForm.tsx:89-98`): nome da pessoa pelo documento.
export { queryBasicData } from './person.api';
export type { QueryBasicData } from './person.wire';
// "Registrar fraude" (unidade 8X, `FraudRecordContainer` do legado) para Pessoas e para a Operação de crédito:
// a porta é leve e o formulário de três passos carrega na primeira abertura. Só por ação humana, com prévia.
export { PERSON_FRAUD_ACTION, PersonFraudRecord, type PersonFraudRecordProps } from './person-fraud-record';
